import { ROUTES } from '#/config/routes';
import {
  createFixedMultiFilterMeta,
  createTextFilterMeta,
} from '#/modules/commonComponents/table/columnFilterMeta';
import { createEditLinkColumn } from '#/modules/commonComponents/table/tableColumnHelpers';
import { renderEntityStatusBadge } from '#/modules/commonComponents/table/entityStatusIconHelpers';
import TruncatedTextWithTooltip from '#/modules/commonComponents/table/TruncatedTextWithTooltip';
import { SUPPLIER_STATUS_FILTER_OPTIONS } from '#/modules/srmMgmt/supplier/helper/supplierFilterOptions';

export function buildSupplierColumns({
  filters = {},
  onFilterChange,
  canShowEdit = () => true,
}) {
  return [
    createEditLinkColumn({
      getEditPath: (row) => ROUTES.supplierEdit(row.id),
      canShowEdit,
    }),
    {
      header: '代號',
      accessorKey: 'code',
      size: 120,
      enableColumnFilter: true,
      meta: createTextFilterMeta({
        key: 'code',
        label: '代號',
        filterValue: filters.code,
        onChange: (value) => onFilterChange('code', value),
        placeholder: '搜尋代號',
      }),
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.code || '—'} />
      ),
    },
    {
      id: 'status',
      header: '狀態',
      accessorKey: 'status',
      size: 96,
      enableColumnFilter: true,
      cell: ({ getValue }) => renderEntityStatusBadge(getValue()),
      meta: createFixedMultiFilterMeta({
        key: 'status',
        label: '狀態',
        options: SUPPLIER_STATUS_FILTER_OPTIONS,
        filterValue: filters.status,
        onChange: (value) => onFilterChange('status', value),
      }),
    },
    {
      header: '名稱',
      accessorKey: 'name',
      size: 180,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'name',
          label: '名稱',
          filterValue: filters.name,
          onChange: (value) => onFilterChange('name', value),
          placeholder: '搜尋名稱',
        }),
      },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.name || '—'} />
      ),
    },
    {
      header: '中文名',
      accessorKey: 'chineseName',
      size: 140,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'chineseName',
          label: '中文名',
          filterValue: filters.chineseName,
          onChange: (value) => onFilterChange('chineseName', value),
          placeholder: '搜尋中文名',
        }),
      },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.chineseName || '—'} />
      ),
    },
    {
      header: '統編',
      accessorKey: 'taxIdNumber',
      size: 120,
      enableColumnFilter: true,
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.taxIdNumber || '—'} />
      ),
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'taxIdNumber',
          label: '統編',
          filterValue: filters.taxIdNumber,
          onChange: (value) => onFilterChange('taxIdNumber', value),
          placeholder: '搜尋統編',
        }),
      },
    },
    {
      header: '電話',
      accessorKey: 'phone',
      size: 120,
      enableColumnFilter: true,
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.phone || '—'} />
      ),
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'phone',
          label: '電話',
          filterValue: filters.phone,
          onChange: (value) => onFilterChange('phone', value),
          placeholder: '搜尋電話',
        }),
      },
    },
  ];
}
